// extracted by extract-css-chunks-webpack-plugin
module.exports = {"marketing-zone":"TD3GV"};